import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=4b750c99&scoped=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=4b750c99&prod&scoped=true&lang=css"
import style1 from "./PhoneNumber.vue?vue&type=style&index=1&id=4b750c99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b750c99",
  null
  
)

export default component.exports